import { NavigatorService } from './shared/navigator/navigator.service';
import { NavigatorAnimations } from './shared/navigator/navigator-animation';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { AnalyticsLibraryService } from './analytics-library.service';

declare let gtag: Function;
declare let gtagads: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss", "./app.component.responsive.scss"],
  animations: [NavigatorAnimations.routeHomeSlide],
  host: {
    class: ''
  }
})
export class AppComponent {
  title = "Configuratore Smart Home | BTicino";

  homeHeader: boolean = false;
  locationUrl: string = '';

  constructor(translate: TranslateService,private router: Router,public ap: AnalyticsLibraryService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang("it");

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use("it");
    //this.createComponent();
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
          //gtag('config', 'UA-20943910-1', { 'page_path': event.urlAfterRedirects });
          //gtagads('config', 'AW-972722374');
          this.changeColorHeader(event);
          this.ap.sendPageView(event.urlAfterRedirects);

          const urlSegments = event.url.split('/');
          const lastSegment = urlSegments[urlSegments.length - 1];
          this.chatBotVisibility(lastSegment);
       }
    });

  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"]
    );
  }

  changeColorHeader(location) {
    if ((location.url == ('/home')) || (location.url == ('/open')) || (location.url == ('/'))) {
      this.homeHeader = true;
      this.locationUrl = location.url;
    } else {
      this.homeHeader = false;
      this.locationUrl = location.url;
    }
  }

  createComponent(){
    const iframeContent = `
      <html>
      <body style="display: flex; align-items: center; justify-content: center; height: 100%;">
        <p style="font-size: 16px;">ChatBOT CREEO</p>
      </body>
      </html>
    `;
    console.log("aggiungo il bot");
    const iframe = document.createElement('iframe');
    iframe.id = 'developBot';
    iframe.srcdoc = iframeContent;
    document.body.appendChild(iframe);
  }

  chatBotVisibility(lastSegment: string){
    //this.hideChatBot();
    if (window.innerWidth < 1039) {
      this.hideChatBot();
    }
    else if ((lastSegment == "whattodo") ||
    (lastSegment == "systems") ||
    (lastSegment == "finishing") ||
    (lastSegment == "havingbticino") ||
    (lastSegment == "summary")){
      this.showChatBot();
    } else {
      this.hideChatBot();
    }
  }
  showChatBot(){
    const convyFrames = document.querySelectorAll('[id*="convy_ai"]');
    convyFrames.forEach((element) => {
      const iframeElement = element as HTMLIFrameElement;
      iframeElement.style.display = 'block';
      iframeElement.style.zIndex = '10';
    });
  }
  hideChatBot(){
    const convyFrames = document.querySelectorAll('[id*="convy_ai"]');
    convyFrames.forEach((element) => {
      const iframeElement = element as HTMLIFrameElement;
      iframeElement.style.display = 'none';
      iframeElement.style.zIndex = '10';
    });
  }
}

